// extracted by mini-css-extract-plugin
export default {"menu":"Sidebar_menu__uBcT8","link":"Sidebar_link__wrCAa","groupHeader":"Sidebar_groupHeader__Ccv-n","title":"Sidebar_title__cDYYT","active":"Sidebar_active__GfHLK"};